import useUserAgent from 'bundles/page/hooks/useUserAgent';

export const useIsMobileCheckoutChangesEnabled = () => {
  const userAgent = useUserAgent();
  const isMobileBrowser = userAgent?.isMobileBrowser ?? false;

  return isMobileBrowser;
};
